// ---------------------------------------------------------------------------
// Field registry — maps field type strings to drivers
// ---------------------------------------------------------------------------
//
// Same pattern as page-registry.js. Page-scoped, not global.

/**
 * Create a field registry.
 * @returns {import('../../contracts/forms.js').FieldRegistry}
 */
export function createFieldRegistry() {
  /** @type {Map<string, import('../../contracts/forms.js').FieldDriver>} */
  const drivers = new Map();

  /**
   * @param {import('../../contracts/forms.js').FieldDriver} driver
   */
  function register(driver) {
    if (!driver.type || typeof driver.type !== 'string') {
      throw new Error('FieldDriver.type must be a non-empty string');
    }
    if (typeof driver.mount !== 'function') {
      throw new Error(`FieldDriver '${driver.type}': mount must be a function`);
    }
    if (drivers.has(driver.type)) {
      throw new Error(`FieldDriver '${driver.type}' is already registered`);
    }
    drivers.set(driver.type, driver);
  }

  /**
   * @param {string} type
   * @returns {import('../../contracts/forms.js').FieldDriver | undefined}
   */
  function get(type) {
    return drivers.get(type);
  }

  /**
   * @returns {string[]}
   */
  function types() {
    return [...drivers.keys()];
  }

  return { register, get, types };
}
